import { apiRequest } from './apiService';

// CRM Tasks
// ============
export const fetchCrmTasks = async () => {
  return await apiRequest('/crm/crm-tasks', 'GET');
};
// ====================
export const createCrmTask = async (taskData: any) => {
  return await apiRequest('/crm/crm-tasks', 'POST', taskData);
};
// ====================
export const updateCrmTask = async (taskId: any, taskData: any) => {
  return await apiRequest(`/crm/crm-tasks/${taskId}`, 'PUT', taskData);
};

// ====================
export const deleteCrmTask = async (taskId: any) => {
  return await apiRequest(`/crm/crm-tasks/${taskId}`, 'DELETE');
};
